import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    leads: [],
    selectedLead: null,
    isLoading: false
};

const leadSlice = createSlice({
    name: "lead",
    initialState,
    reducers: {
        setLeads: (state, action) => {
            state.leads = action.payload;
        },
        setSelectedLead: (state, action) => {
            state.selectedLead = action.payload;
        },
        removeLead: (state, action) => {
            state.leads = state.leads.filter(l => l._id !== action.payload);
        }
    }
});

export const {
    setLeads,
    setSelectedLead,
    removeLead
} = leadSlice.actions;

export const LeadReducer = leadSlice.reducer;